import React from "react";
import LearningCalendarContent from "../function-components/LearningCalendar/LearningCalendarContent";

function LearningCalendar() {
  return (
    <>
      <LearningCalendarContent />
    </>
  );
}

export default LearningCalendar;
